export default __webpack_public_path__ + "static/media/spain.069dd495.svg";